// §5 date lock (backend PR #7027): once an appointment has an outcome recorded
// (attended / failed to attend / cancelled) its date is fixed — a new visit is a
// new appointment. The backend answers a date change on such an appointment with
// HTTP 409 and a stable payload; this module is the one place the frontend
// recognises it, so every write path shows the same sentence and leaves local
// state untouched.
//
// Backward-compatible by design: a backend without the lock never sends this
// payload, so the frontend can ship first.
export const APPOINTMENT_DATE_LOCK_CODE = 'appointment_date_locked';

export const APPOINTMENT_DATE_LOCK_MESSAGE =
    'This appointment already has an outcome recorded, so its date cannot change. Book a new appointment for the new date.';

export const OUTCOME_STATUSES = Object.freeze(['ATTENDED', 'FAILED_TO_ATTEND', 'CANCELLED']);

export function hasRecordedOutcome(status) {
    return OUTCOME_STATUSES.includes(String(status || '').toUpperCase());
}

export function isAppointmentDateLocked(response) {
    return response?.status === 409 && response?.data?.code === APPOINTMENT_DATE_LOCK_CODE;
}

// The backend's own sentence wins when present so the two surfaces never drift.
export function appointmentDateLockMessage(response) {
    const detail = response?.data?.detail;
    return typeof detail === 'string' && detail.trim() ? detail : APPOINTMENT_DATE_LOCK_MESSAGE;
}
